import { Action, createAction, props } from '@ngrx/store';

import { ScannedCode, ScannedCodeType } from 'app/features/scan-flow/models';

export const openScanQrDialog = createAction(
    '[ScannedCodes] Scan New Code',
    props<{
        allowedCodeTypes: ScannedCodeType[];
        onScanFinishedAction: Action | undefined;
        token: string;
    }>(),
);

export const addScannedCode = createAction(
    '[ScannedCodes] Add Scanned Barcode ',
    props<{ token: string; code: string }>(),
);

export const setScanFlowScannedCodes = createAction(
    '[ScanFlow] Set Scanned Code',
    props<{ scannedCode: ScannedCode }>(),
);

export const processScannedCode = createAction(
    '[ScanFlow] Process Scanned Code',
    props<{ scannedText: string }>(),
);

export const removeScannedCodeFromFlow = createAction(
    '[ScanFlow] Remove Scanned Code',
    props<{ code: string }>(),
);

export const resetScannedCode = createAction('[ScannedCodes] Reset Scanned Code', props<{ token: string }>());
